/*
 * @Author: shuchang
 * @Date: 2021-09-15 10:50:31
 * @LastEditors: shuchang
 * @LastEditTime: 2021-09-15 11:05:08
 * @Description: 
 */
module.exports = {
    API_URL: "https://apiapp.guojutech.net",
    FILE_URL: ""
}